import React, { useEffect, useRef } from 'react'
import { ReactComponent as ArrowDownIcon } from '../assets/arrow-down.svg'
import { ReactComponent as CrossIcon } from '../assets/cross.svg'
import logo from "../assets/logo.png";

export default function LeftBar() {
    const eventListeners = useRef(null);
    const leftMenuContainer = useRef(null);

    const menuClickHandler = (e) => {
        const menu = e.target;
        const parent = menu.parentElement;
        const subMenu = parent.querySelector('.sub-menu');
        const rect = subMenu.getBoundingClientRect();
        const oldActive = parent.parentElement.querySelector('.active');

        if (parent.classList.contains('active')) {
            parent.classList.remove('active');
            parent.style.height = 30 + 'px';
            parent.style.minHeight = 30 + 'px';
        } else {
            parent.style.height = 30 + rect.height + 'px';
            parent.style.minHeight = 30 + rect.height + 'px';
            if (oldActive) {
                oldActive.classList.remove('active');
                oldActive.style = ''
            }
            parent.classList.add('active');
        }
    }

    const menuClose = () => {
        const active = document.querySelector('.left-bar-container.active');

        if (active) {
            active.classList.remove('active');
        }
    }

    useEffect(() => {
        const scrollWithOffset = (element, offset = 20) => {
            const outerContainer = document.querySelector('.boxes-container-outer');
            if (!outerContainer || !element) return;

            const elementTop = element.getBoundingClientRect().top;
            const containerTop = outerContainer.getBoundingClientRect().top;

            const scrollTop = outerContainer.scrollTop + (elementTop - containerTop) - offset;

            outerContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });
        };

        const clickFunctions = (e) => {
            const target = e.target;
            const menu = target.closest('.menu');

            if (!menu) return;

            const currentMenuIndex = Array.prototype.indexOf.call(menu.parentNode.children, menu);
            const currentSubMenuIndex = Array.prototype.indexOf.call(target.parentNode.children, target);

            const searchQ = `//div[text()="${target.textContent.trim()}"]`;
            const foundElm = document.evaluate(searchQ, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

            if (foundElm) {
                const contentBox = foundElm.parentElement;
                const contentBoxParent = contentBox?.closest('.box-container');
                if (contentBoxParent) {
                    scrollWithOffset(contentBoxParent, 20);
                }
            } else {
                const allContentSections = document.querySelectorAll('.section');
                const targetSection = allContentSections[currentMenuIndex - 1];
                if (targetSection) {
                    const boxContainers = targetSection.querySelectorAll('.box-container');
                    const targetBox = boxContainers[currentSubMenuIndex];
                    if (targetBox) {
                        scrollWithOffset(targetBox, 20);
                    }
                }
            }

            const active = document.querySelector('.left-bar-container.active');
            if (active) {
                active.classList.remove('active');
            }
        };

        if (leftMenuContainer.current) {
            const allSubMenus = leftMenuContainer.current.querySelectorAll('.sub-menu span');

            allSubMenus.forEach((menu) => {
                menu.addEventListener('click', clickFunctions);
                if (eventListeners.current === null) {
                    eventListeners.current = [menu];
                } else {
                    eventListeners.current.push(menu);
                }
            });
        }

        return () => {
            if (eventListeners.current && eventListeners.current.length > 0) {
                eventListeners.current.forEach((ev) => ev.removeEventListener('click', clickFunctions));
                eventListeners.current = [];
            }
        };
    }, []);

    return (
        <div className='left-bar-container' ref={leftMenuContainer}>
            <div className="left-menu-bar-top">
                <div className="logo">
                    <img src={logo} width={150} alt="logo" />
                </div>
                <div className="menu-close" onClick={menuClose}>
                    <CrossIcon width={20} height={20} />
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section I: Classes</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Add a Class</span>
                    <span>Copy a Class</span>
                    <span>Edit a Class</span>
                    <span>Add Class Notes</span>
                    <span>Delete a Class</span>
                    <span>Select a Class</span>
                    <span>Configure a Grade Scale</span>
                    <span>Copy a Grade Scale</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section II: Rosters and Students</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Create Class Roster</span>
                    <span>Quick Add Student</span>
                    <span>Edit Student</span>
                    <span>Add or Edit Student Photo</span>
                    <span>Copy Student</span>
                    <span>Import Roster</span>
                    <span>Drop Student</span>
                    <span>Delete Student</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section III: Categories</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Add Category</span>
                    <span>Edit Category</span>
                    <span>Delete Category</span>
                    <span>Copy Categories</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section IV: Assignments</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Create Assignment</span>
                    <span>Edit Assignment</span>
                    <span>Delete Assignment</span>
                    <span>Quick Add Assignment</span>
                    <span>Copy Assignment</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section V: Scores</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Record Scores</span>
                    <span>Edit a Score</span>
                    <span>Mark All Unscored Assignments</span>
                    <span>Add Assignment Notes</span>
                    <span>Create an Exception</span>
                    <span>Find Missing Scores</span>
                    <span>Import Scores</span>
                    <span>Copy Short Scores</span>
                    <span>Edit a Short Score</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section VI: Attendance</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Record Attendance</span>
                    <span>Add Attendance Notes</span>
                    <span>Email Students</span>
                    <span>Email an Attendance Record</span>
                    <span>Edit an Attendance Record</span>
                    <span>Delete an Attendance Record</span>
                    <span>Quick Add Attendance Record</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section VII: Behavior</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Record Behavior</span>
                    <span>Add Behavior Notes</span>
                    <span>Email Students</span>
                    <span>Edit a Behavior Record</span>
                    <span>Delete a Behavior Record</span>
                    <span>Quick Add Behavior Record</span>
                    <span>Assign Custom Behavior Labels</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section VIII: Student Progress</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Standard Grade Scale Statistics</span>
                    <span>Weighted Grade Scale Statistics</span>
                    <span>Recorded Scores</span>
                    <span>Email Student Menu</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section IX: Importing Class Rosters</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Step 1: Create the Files to Import</span>
                    <span>Step 2: Copy the Files to the iOS Device</span>
                    <span>Step 3: Import the Files to a Class Roster</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section X: Importing Scores</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Step 1: Create the Files to Import</span>
                    <span>Step 2: Copy the Files to the iOS Device</span>
                    <span>Step 3: Import the Scores</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XI: iTunes File Sharing</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Section XI: iTunes File Sharing</span>
                    <span>Send a File to the iOS Device</span>
                    <span>Get a File from the iOS Device</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XII: Help & Support</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Customer Support</span>
                    <span>Knowledge Base</span>
                    <span>Instruction Manual</span>
                    <span>Email Support</span>
                    <span>Dropbox Support</span>
                    <span>News & Announcements</span>
                    <span>Tell a Friend</span>
                    <span>Tweet @GradeBookPro</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XIII: Data</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Reports</span>
                    <span>File Management</span>
                    <span>Dropbox</span>
                    <span>Security</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XIV: Class / Student / Assignment Report Generators</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Classes / Class</span>
                    <span>Report Types</span>
                    <span>Report Formats</span>
                    <span>Destinations</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XV: Settings</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Appearance</span>
                    <span>Record Configuration</span>
                    <span>Report Configuration</span>
                    <span>View Configuration</span>
                    <span>Diagnostics</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Section XVI: Random Group Generator</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Create a List</span>
                    <span>Share a List</span>
                    <span>Notes</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Appendix A: Data Management</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Report Export</span>
                    <span>Archive</span>
                    <span>iTunes and iCloud Backup & Restore</span>
                    <span>Recommended Backup Plan</span>
                    <span>Security:</span>
                    <span>Moving Data to a New Device</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Appendix B: Importing Unicode CSV Files to Excel</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Importing CSV Files to Microsoft Excel</span>
                </div>
            </div>
            <div className="menu">
                <div className="menu-inner" onClick={menuClickHandler}>
                    <span className='menu-name'>Appendix C: Toolbar Icons</span>
                    <span className='menu-icon'>
                        <ArrowDownIcon width={15} height={15} />
                    </span>
                </div>
                <div className="sub-menu">
                    <span>Toolbar Icons</span>
                </div>
            </div>
        </div>
    )
}